import { SqsSocketTypes } from "../types/working-model";
import { Post, PostHv } from "./helpers";

export function SaveChatMessage(
	session: number,
	content: string,
	token: string
): Promise<any> {
	return Post("/v3/admin/events/session/chat", token, {
		session,
		content
	});
}

export const CreateLiveChatOrQuestionMessage = async (session: number, body: { [key: string]: any }, token: string, message_type?: SqsSocketTypes): Promise<any> => {
	return PostHv(`/e3-comment/${session}`, { ...body, message_type: message_type || 'chat' }, token)
		.then(async res => {
			return res;
		}).catch(e => {
			throw new Error(e);
		});
};
